import { SellerFilter, MarketplaceFilter, ProductFilter, DatePickerFilter } from '@/components/new-filters';
import { EVENTS } from '@/utils/constants';
import SegmentFilter from "@/components/new-filters/SegmentFilter.vue";
import BrandFilter from "@/components/new-filters/BrandFilter.vue";
import EmptySegments from "@/components/EmptySegments.vue";
import MultiModeDatePicker from "@/components/MultiModeDatePicker.vue";
import MultiModeDatePickerUIText from '@/components/MultiModeDatePickerUIText.vue';
import { processDate } from '@/utils';
import { mapState } from "vuex";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
export default {
  name: 'ProfitAndLossFilters',
  components: {
    SellerFilter,
    MarketplaceFilter,
    ProductFilter,
    DatePickerFilter,
    MultiModeDatePicker,
    MultiModeDatePickerUIText,
    SegmentFilter,
    BrandFilter,
    EmptySegments
  },
  mixins: [LiteTableMixin],
  expose: ['datePicker'],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.profitAndLoss.sellers_filter,
      marketplaces_filter: state => state.profitAndLoss.marketplaces_filter,
      products: state => state.profitAndLoss.products,
      segments_filter: state => state.profitAndLoss.segments_filter,
      brands_filter: state => state.profitAndLoss.brands_filter
    }),
    showBrandsFilter() {
      return this.brands_filter.defaultList.length > 1;
    },
    datePicker() {
      return this.$refs.datePicker;
    },
    datePickerDate() {
      return this.$store.getters.profitAndLossGetAggregatePeriod();
    },
    datePickerDisplayDate() {
      return type => {
        const {
          date,
          format
        } = this.datePickerDate[type];
        if (this.datePickerDate.title === 'Quarterly') {
          // Return `Q{1-4} {year}` format
          return `Q${processDate(date, format)}`;
        }
        return processDate(date, format);
      };
    }
  },
  methods: {
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        this.products.clearAndApply();
        this.segments_filter.clearAndApply();

        // This await is very important, because we need to wait for the new marketplace to be set
        // Note: Whenever, wherever we apply the sellers, we need to trigger the sub filters to be refreshed (in this async await manner.)
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for sellers...  ',
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS_SELLERS_SUB_FILTERS);
        window.$bus.trigger('showSuccess', {
          visible: false,
          message: ""
        });
        window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        this.products.clearAndApply();
        this.segments_filter.clearAndApply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for marketplace...  ',
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS_MARKETPLACES_SUB_FILTERS);
        window.$bus.trigger('showSuccess', {
          visible: false,
          message: ""
        });
        window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS);
      }
    },
    applyProducts() {
      if (this.products.isModified) {
        this.products.apply();
        window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS);
      }
    },
    applyBrands() {
      if (this.brands_filter.isModified) {
        this.brands_filter.apply();
        window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS);
      }
    },
    async applySegments() {
      if (this.segments_filter.isModified) {
        this.segments_filter.apply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching product filters for segments...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS_PRODUCTS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS);
      }
    },
    async handleDatePickerSubmit(state) {
      this.$refs.datePickerFilter.close();
      await window.$bus.trigger(EVENTS.PROFIT_AND_LOSS_DATE_PICKER_SUBMIT, state);
    },
    handleDatePickerCancel() {
      this.$nextTick().then(() => {
        this.$refs.datePicker.reset(this.datePickerDate);
        this.$refs.datePickerFilter.close();
      });
    },
    async handleProductsCleared() {
      window.$bus.trigger('showSuccess', {
        message: '⏳Refreshing...  ',
        visible: true,
        delay: 10
      });
      await window.$bus.trigger(EVENTS.REFRESH_PROFIT_AND_LOSS);
    }
  }
};